/* eslint-disable @typescript-eslint/no-explicit-any */
import { login } from '@kk/h5-sdk';
import { webview, ua } from '@kk/utils';
import toast from '@kk/toast';
import { miniNav } from '@kk-activity-factory/utils';
import bus, { busEvent } from '@kk-activity-factory/bus';

export default function (options: any) {
    if (ua.miniprogram) {
        if ((window as any).isJsSDKReady) {
            miniNav('/pages/login/login');
        } else {
            toast.show('资源图片努力加载ing，请稍等~');
            setTimeout(() => miniNav('/pages/login/login'), 2000);
        }
    } else {
        if (webview.isKuaikan) {
            login(options);
        } else {
            bus.$emit(busEvent.OPEN_DEEPLINK_GUIDE);
        }
    }
}
